
<template>

	<!-- <div>

		
		<myframe title="Дерево подгрупп" expanded>

			<tree v-if="tree != null" :data="tree" :options="tree_options"/>

		</myframe>
		

		
	</div> -->
	<objects title="Список оценочных групп/подгрупп" :objects="groups" :attrs_all="attrs" set_page_local />

</template>

<script>

import objects from "../../widgets/objects"

export default
{
	components :
	{
		objects,
	},

	props :
	{
		id : String,
		data : Object,
		full_name : String,
	},

	data()
	{
		return {
			
			tree : null,
			tree_options :
			{
				expanded : true,
				multiple : false,
			},

			groups : [],
			
		}
	},

	watch :
	{
		data :
		{
			immediate : true,

			handler(data)
			{
				this.refresh(data)
			}
		}
	},

	computed :
	{
		attrs()
		{
			let attrs = [
				{
					key : "full_name", label : "Наименование оценочной группы/подгруппы", sortable : true, type : "str", align_header: "left", align : "left",
					my_formatter :
						data =>
						{
							const value = data.value
							const pos = value.replace(this.full_name, "").split("/").length - 1
							const margin = 10 * pos

							return { style : `margin-left: ${margin}px`, value : value }
						},
				},
				{ key : "objects_count", label : "Общее количество ОО", sortable : true, type : "number", align_header: "left", align : "right", url : { router_name : "objects", make_query : data => this.make_query(data, "all"), make_key : data => "ОО_" + data.id } },
				// { key : "objects_count_exactly", label : /*<br/>*/"Разгруппированных в данную группу", sortable : true, type : "number", url : { router_name : "objects", make_query : data => this.make_query(data, "exactly"), key : "ОО_" + this.id } },
				// { key : "objects_count_right", label : "Количество ОО<br/>Разгруппированных в оценочную группу/подгруппу", sortable : true, type : "number", url : { router_name : "objects", make_query : data => this.make_query(data, "right"), key : "ОО_" + this.id } },
				{ key : "objects_count_bad", label : /*<br/>*/"ОО, не разгруппированных в оценочную группу/подгруппу", sortable : true, type : "number", align_header: "left", align : "right", url : { router_name : "objects", make_query : data => this.make_query(data, "bad"), make_key : data => "ОО_" + data.id } },
			]

			if (!this.data.not_editable)
			{
				attrs = [
					attrs[0], 
					attrs[1],
					{ key : "analogues_count", label : "Общее количество ОА", sortable : true, type : "number", align_header: "left", align : "right", url : { router_name : "analogues", make_query : data => this.make_query(data, "all"), make_key : data => "ОА_" + data.id } },
					attrs[2],
					{ key : "analogues_count_bad", label : /*<br/>*/"ОА, не разгруппированных в оценочную группу/подгруппу", sortable : true, type : "number", align_header: "left", align : "right", url : { router_name : "analogues", make_query : data => this.make_query(data, "bad"), make_key : data => "ОА_" + data.id  } },
				]
			}
			return attrs
		},
	},

	methods :
	{
		refresh(data)
		{
			if(data.children_tree.id)
			{
				var desc = this.create_tree_and_table(data.children_tree)

				this.tree = desc.tree
				this.groups = desc.groups
			}
		},

		create_tree_and_table(elem)
		{
			var tree =
			{
				text : `${elem.name} / ${elem.objects_count} / ${elem.objects_count_bad}`,
				children : []
			}
			var groups = [ elem ]

			elem.children.forEach(
				child =>
				{
					var desc = this.create_tree_and_table(child)

					tree.children.push(desc.tree)
					groups = [ ...groups, ...desc.groups]
				})

			return { tree : tree, groups : groups }
		},

		make_query(data, type)
		{
			var query

			if(type == "all")
				query = `{"and":[{"keys":["cadastral_group"],"operation":"cadastral_group","args":["${data.id}","${data.full_name}"]}]}`
			else if(type == "exactly")
				query = `{"and":[{"keys":["cadastral_group_exactly"],"operation":"cadastral_group_exactly","args":["${data.id}","${data.full_name}"]}]}`
			else if(type == "right")
				query = `{"and":[{"keys":["cadastral_group_right"],"operation":"cadastral_group_right","args":["${data.id}","${data.full_name}"]}]}`
			else if(type == "bad")
				query = `{"and":[{"keys":["cadastral_group_bad"],"operation":"cadastral_group_bad","args":["${data.id}","${data.full_name}"]}]}`

			return query
		},
	}
}

</script>

